import React from 'react';
export function AppendixScoringSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-104">
      <div className="flex flex-col md:flex-row w-full h-full min-h-0" data-id="element-105">
        {/* Left Panel */}
        <div className="flex flex-col justify-center w-full md:w-[45%] flex-shrink-0 min-h-0 overflow-hidden" style={{
        borderLeft: '3px solid #4A90D9',
        padding: 'var(--slide-padding)'
      }} data-id="element-106">
          <p className="italic font-semibold mb-[clamp(0.5rem,1.5vw,1rem)] animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          animationDelay: '0.1s'
        }} data-id="element-107">
            Experiment 01
          </p>
          <h2 className="font-black tracking-tight text-white leading-[1.1] mb-[clamp(1rem,2vw,1.5rem)] animate-fade-slide" style={{
          fontSize: 'var(--h2-size)',
          animationDelay: '0.2s'
        }} data-id="element-108">
            Navi route vs.
            <br data-id="element-109" />
            Google route
          </h2>
          <p className="text-white/70 leading-relaxed animate-fade-slide" style={{
          fontSize: 'var(--body-size)',
          animationDelay: '0.3s'
        }} data-id="element-110">
            We score every road segment across 7 pedestrian-relevant dimensions
            using public data sources (NASA nightlight imagery, crash databases,
            OSM, pedestrian activity signals) — then generate walking routes
            that optimize for experience, not just speed.
            <br data-id="element-111" />
            <br data-id="element-112" />
            Side-by-side comparisons show Navi routes consistently choose safer,
            more scenic, and more walkable paths than Google's shortest-distance
            defaults. Currently covering 9 metros.
          </p>
        </div>

        {/* Right Panel */}
        <div className="flex-1 flex items-center justify-center p-[var(--slide-padding)] min-h-0 relative" data-id="element-113">
          <div className="w-full h-full relative rounded-xl overflow-hidden animate-fade-slide" style={{
          animationDelay: '0.4s'
        }} data-id="element-114">
            <img src="https://cdn.magicpatterns.com/uploads/xb2eXSCzQNgh1szEiNkRmP/routing.png" alt="Walkability heatmap routing interface" className="absolute inset-0 w-full h-full object-contain" style={{
            filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))'
          }} data-id="element-115" />
          </div>
        </div>
      </div>
    </section>;
}